<template>
  <button
    v-bind="$attrs"
    :class="buttonClasses"
    :type="type"
    :disabled="disabled"
    :aria-pressed="active"
  >
    <span :class="style.text">
      {{ avatarText }}
    </span>
  </button>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./TabUserAvatar.module.scss";

export default defineComponent({
  name: "TabUserAvatar",
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<ButtonTypeClick>,
      default: "button"
    }
  },
  data() {
    return {
      style
    };
  },
  computed: {
    avatarText(): string {
      return this.text.trim().slice(0, 2).toUpperCase();
    },

    buttonClasses(): Array<string | Record<string, boolean>> {
      return [
        this.style.tabUserAvatar,
        {
          [this.style.active]: this.active,
          [this.style.disabled]: this.disabled
        }
      ];
    }
  }
});
</script>
